<template>
    <svg
        width="24px"
        height="24px"
        viewBox="0 22 161.84 186.55"
    >
        <path :fill="color" class="st0" d="M130.23,73.77l-3.99,4.03c-2.19,2.21-5.75,2.21-7.96,0L88.66,49.07v77.05c0,4.69-3.81,8.5-8.48,8.5h-0.01 c-4.69,0-8.5-3.8-8.5-8.5v-76.4L43.6,76.95c-2.21,2.23-5.79,2.23-7.99,0l-3.99-4.04c-2.22-2.23-2.22-5.85,0-8.1L76.88,20.9 c2.19-2.23,5.79-2.23,7.97,0l4.01,4.05c0.51,0.52,0.87,1.11,1.14,1.74l40.23,39.03C132.43,67.94,132.43,71.56,130.23,73.77z M147.84,143.75v28.8H14v-28.8H0v28.8v13.2v0.8h161.84v-0.8v-13.2v-28.8H147.84z"/>
    </svg>

</template>
<script>
export default {
    props: {
        color: {
            type: String,
            default: '#636772'
        }
    }
}
</script>
<style lang="sass" scoped>
@import "@/styles/vars.sass"
// path
//     fill: #636772
// .icon-planet.is-white
//     path
//         fill: #FFF
</style>
